import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

// eslint-disable-next-line import/prefer-default-export
export const postDelayProfile = async (
  startTime,
  deltaTime,
  scheduleType,
  proteinVolume,
  bufferVolume,
  profileConfig,
  id = null,
) => {
  const data = {
    StartTime: startTime,
    DeltaTime: deltaTime,
    ScheduleType: scheduleType,
    VolumeConfirmation: {
      ProteinVolume: proteinVolume,
      BufferVolume: bufferVolume,
    },
    DeviceElementCheckList: [0],
    ProfileConfig: profileConfig,
    Id: id,
  };
  const response = await axiosMethods.post(RestAPI.SET_DELAY_PROFILE, data);
  return response;
};

export const getDelayProfile = async () => {
  const response = await axiosMethods.get(RestAPI.DELAY_PROFILE);
  return response;
};

export const removeDelayProfile = async () => {
  const response = await axiosMethods.delete(RestAPI.DELAY_PROFILE);
  return response;
};
